export var EnumChangeValue;
(function (EnumChangeValue) {
    EnumChangeValue[EnumChangeValue["Value0"] = 0] = "Value0";
    EnumChangeValue[EnumChangeValue["Value1"] = 1] = "Value1";
    EnumChangeValue[EnumChangeValue["Change"] = 2] = "Change";
})(EnumChangeValue || (EnumChangeValue = {}));
